import BlockingScreenLayer from "../common/containers/BlockingScreenLayer";
import { FULLY_BLOCKING_POPUP_ZINDEX as zIndex } from "../../utils/constants/otherConstants";
import LoadingBar from "./LoadingBar";

const TooManyRequestsBlocker = () => {
    return (
        <BlockingScreenLayer zIndex={zIndex}>
            <div className="d-flex flex-row jc-center ai-center full-height">
                <LoadingBar customLoadingText={"Too many requests to Spotify API right now. Please, wait for a few seconds."} />
            </div>
        </BlockingScreenLayer>
    )
}

export default TooManyRequestsBlocker;